// Campaigns New - Alpine.js Component
// Handles new campaign creation with form validation and date pickers

document.addEventListener('alpine:init', () => {

    Alpine.data('campaigns_new_x_data', () => ({
        // Form data properties
        campaign_name: '',
        campaign_primary_goal: '',
        campaign_targeting_parameters: '',
        campaign_budget: null,
        campaign_start_date: '',
        campaign_end_date: '',

        init() {
            // Initialize Flatpickr for start date
            this.startDatePicker = flatpickr("#campaign_start_date", {
                dateFormat: "Y-m-d",
                minDate: "today",
                onChange: (selectedDates, dateStr) => {
                    this.campaign_start_date = dateStr;
                    // Update end date min date to be after start date
                    if (this.endDatePicker) {
                        this.endDatePicker.set('minDate', dateStr);
                    }
                }
            });
            
            // Initialize Flatpickr for end date
            this.endDatePicker = flatpickr("#campaign_end_date", {
                dateFormat: "Y-m-d",
                minDate: "today",
                onChange: (selectedDates, dateStr) => {
                    this.campaign_end_date = dateStr;
                }
            });
            
            // Watch for changes to campaign_budget and ensure it's a whole number
            this.$watch('campaign_budget', (value) => {
                if (value !== null && value !== '') {
                    const numericValue = parseFloat(value);
                    if (!isNaN(numericValue) && numericValue !== Math.floor(numericValue)) {
                        this.campaign_budget = Math.floor(numericValue);
                    }
                }
            });
        },

        validate_campaign_form(action_type) {
            if (action_type === 'draft') {
                // Only require campaign name for draft
                if (!this.campaign_name || this.campaign_name.trim() === '') {
                    alert('Campaign name is required to save as draft.');
                    return false;
                }
                // For draft, if budget is provided, it must meet minimum
                if (this.campaign_budget && this.campaign_budget < 1000) {
                    alert('Campaign budget must be at least $1000.');
                    return false;
                }
            } else if (action_type === 'next') {
                // Require all fields for next
                if (!this.campaign_name || this.campaign_name.trim() === '') {
                    alert('Campaign name is required.');
                    return false;
                }
                if (!this.campaign_primary_goal || this.campaign_primary_goal === '') {
                    alert('Please select your primary goal.');
                    return false;
                }
                if (!this.campaign_targeting_parameters || this.campaign_targeting_parameters === '') {
                    alert('Please select your targeting parameters.');
                    return false;
                }
                if (!this.campaign_budget || this.campaign_budget < 1000) {
                    alert('Campaign budget must be at least $1000.');
                    return false;
                }
                if (!this.campaign_start_date || this.campaign_start_date === '') {
                    alert('Start date is required.');
                    return false;
                }
                if (!this.campaign_end_date || this.campaign_end_date === '') {
                    alert('End date is required.');
                    return false;
                }
                if (new Date(this.campaign_start_date) >= new Date(this.campaign_end_date)) {
                    alert('End date must be after start date.');
                    return false;
                }
            }

            return true;
        },

        submit_campaign_form(action_type) {
            // Validate form first
            if (!this.validate_campaign_form(action_type)) {
                return false;
            }

            // Set submission type in hidden field
            document.getElementById('submission_type').value = action_type;

            // Collect survey data
            const surveyData = {
                primary_goal: this.campaign_primary_goal,
                targeting_parameters: this.campaign_targeting_parameters
            };

            document.getElementById('campaign_survey_data').value = JSON.stringify(surveyData);

            document.getElementById('campaign-form').submit();
            return false; // Prevent any additional form submission
        },
    }));

});